<template>
  <div>
    <div class="card col-md-7">
      <div class="card-content">
        <div class="col">
          <form>
            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('company')"
                  :placeholder="$t('company_name')"
                  v-model="user.company"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('vat_tax_number')"
                  :placeholder="$t('vat_tax_number')"
                  v-model="user.vat_number"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('coc_kvk_number')"
                  :placeholder="$t('coc_kvk_number')"
                  v-model="user.coc"
                ></fg-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <fg-input type="email" :label="$t('email')"
                  :placeholder="$t('email')" v-model="user.email"></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('first_name')"
                  :placeholder="$t('first_name')"
                  v-model="user.first_name"
                ></fg-input>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('last_name')"
                  :placeholder="$t('last_name')"
                  v-model="user.last_name"
                ></fg-input>
              </div>
              
            </div>

            <div class="row">
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('sms_notification_number')"
                  :placeholder="$t('sms_notification_number_leave_empty_disable')"
                  v-model="user.notification_phone_number"
                ></fg-input>
                <small>
                  <i>Leave empty to disable SMS notifications - make sure to add country code! example: +0112345678</i>
                </small>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('address_line')"
                  :placeholder="$t('address_line')"
                  v-model="user.address_1"
                ></fg-input>
              </div>
              <div class="col-md-4" v-if="user.settings">
                <fg-input
                  type="text"
                  :label="$t('email_address_invoices')"
                  :placeholder="$t('email_address_invoices')"
                  v-model="user.settings.invoice_email"
                ></fg-input>
                <small><i> {{ $t('leave_empty_not_receive_invoice_emails')}}</i></small>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <fg-input type="text" :label="$t('city')"
                  :placeholder="$t('city')" v-model="user.city"></fg-input>
              </div>
              <div class="col-md-4">
                <label for="country">{{ $t('country')}}</label>
                <select
                  :class="{ 'select-warning' : !user.country, 'select-success' : user.country}"
                  class="form-control"
                  size="large"
                  placeholder="Select country"
                  v-model="user.country"
                  v-validate="'required'"
                  name="country"
                >
                  <option
                    v-for="(country, key) in countryList"
                    class="select-primary"
                    :value="country.code"
                    :label="country.name"
                    :key="key"
                  ></option>
                </select>
              </div>
              <div class="col-md-4">
                <fg-input
                  type="text"
                  :label="$t('zip_code')"
                  :placeholder="$t('zip_code')"
                  v-model="user.zipcode"
                ></fg-input>
              </div>
            </div>
            <div class="text-center">
              <button
                type="submit"
                class="btn btn-info btn-fill btn-wd"
                @click.prevent="updateProfile"
              >
                <i class="fas fa-save"></i> {{ $t('update_profile') }}
              </button>
            </div>

            <div class="clearfix"></div>
            <br />
            <br />
          </form>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="col-md-1"></div>
    <div class="card col-md-4">
      <div class="card-content">
        <h3>{{ $t('notification_settings') }}</h3>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">{{ $t('subject') }}</th>
              <th scope="col">{{ $t('email') }}</th>
              <th scope="col">{{ $t('sms') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t('file_uploaded') }}</td>
              <td>
                <p-switch v-model="notifications.file_upload.email" class="termsConditions">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </p-switch>
              </td>
              <td>
                <p-switch v-model="notifications.file_upload.sms" class="termsConditions">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </p-switch>
              </td>
            </tr>
            <tr>
              <td>{{ $t('modified_file_ready_for_download') }}</td>
              <td>
                <p-switch v-model="notifications.file_ready.email" class="termsConditions">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </p-switch>
              </td>
              <td>
                <p-switch v-model="notifications.file_ready.sms" class="termsConditions">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </p-switch>
              </td>
            </tr>
            <tr>
              <td>{{ $t('tickets_new_replies') }}</td>
              <td>
                <p-switch v-model="notifications.ticket_replies.email" class="termsConditions">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </p-switch>
              </td>
              <td>
                <p-switch v-model="notifications.ticket_replies.sms" class="termsConditions">
                  <i class="fa fa-check" slot="on"></i>
                  <i class="fa fa-times" slot="off"></i>
                </p-switch>
              </td>
            </tr>
          </tbody>
        </table>
        <span
          class="text-warning"
        >{{ $t('sms_only_works_supplier_entered') }}</span>
        <div class="clearfix"></div>
        <div class="col">
          <span class="col-md-12 text-center" v-if="avatarLocation">
            <img :src="avatarLocation" />
            <hr />
          </span>
          <h4 class="title">{{ $t('change_avatar') }}</h4>
          <vue-dropzone
            ref="uploadAvatar"
            id="dropzone"
            :options="dropzoneOptions"
            v-on:vdropzone-success="uploadSuccess"
            style="font-family: 'Roboto', Arial, Verdana; "
          ></vue-dropzone>
        </div>
        <br />
        <br />
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import PSwitch from "src/components/UIComponents/Switch.vue";
export default {
  components: {
    vueDropzone: vue2Dropzone,
    PSwitch
  },
  data() {
    return {
      notifications: {
          file_upload: {
            email: false,
            sms: false
          },
          file_ready: {
            email: false,
            sms: false
          },
          ticket_replies: {
            email: false,
            sms: false
          }
        },
      user: {
        company: "",
        first_name: "",
        email: "",
        last_name: "",
        address: "",
        city: "",
        postalCode: "",
        about: "",
        settings: {
          invoice_email: ""
        }
      },
      countryList: "",
      avatarLocation: "",
      dropzoneOptions: {
        paramName: "avatar",
        url: APIURL + "/profile/avatar",
        maxNumberOfFiles: 1,
        uploadMultiple: false,
        parallelUploads: 1,
        thumbnailWidth: 250,
        maxFilesize: 2,
        timeout: 180000,
        dictDefaultMessage:
          "<h1><i class='fa fa-cloud-upload-alt fa-2x'></i></h1><h3>" + this.$t('upload_avatar_here')+ "</h3>",
        headers: {
          Authorization: "Bearer " + Ls.get("access_key"),
          "CTR-Access-Key": SITEKEY
        }
      }
    };
  },
  methods: {
    updateProfile() {
      this.user.settings.notifications = this.notifications;
      Webservice.updateProfile(this.user).then(resp => {
        if (resp.data == "success") {
          this.$notify({
            component: {
              template: `<h5>Profile updated!</h5>`
            },
            icon: "fas fa-check",
            type: "success"
          });
          Webservice.getAvatar();
        } else {
          this.$notify({
            component: {
              template: `<h5>Something went wrong!</h5>Could not update profile :(`
            },
            icon: "fas fa-warn",
            type: "error"
          });
        }
      });
    },
    uploadSuccess(file, response) {
      if (response) {
        this.uploadData.files = response;
        this.$notify({
          component: {
            template: "<span>Avatar uploaded!</span>"
          },
          icon: "fas fa-check",
          type: "success"
        });
      }
    },
    getAllCountries() {
      this.countryList = General.getAllCountries();
    }
  },
  mounted() {
    this.getAllCountries();
    this.user = Webservice.getUser().then(response => {
      if (response.data) {
        this.user = response.data;
        if (!response.data.settings) {
          this.user.settings = {
            invoice_email: ""
          };
        }
        if (typeof response.data.settings.notifications == "undefined") {
          this.notifications = {
            file_upload: {
              email: false,
              sms: false
            },
            file_ready: {
              email: false,
              sms: false
            },
            ticket_replies: {
              email: false,
              sms: false
            },
          };
        } else {
          this.notifications = response.data.settings.notifications;
        }
        if (response.data.avatar) {
          this.avatarLocation = APIURL + "/../.." + response.data.avatar;
        }
      }
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile/EditProfileForm.vue